import { faTrafficCone } from "@fortawesome/pro-solid-svg-icons";
import EditorSidebarTabs from "../../../ItemCatalog/EditorSidebarTabs";
import { useEditorSidebarTabKey } from "../../../ItemCatalog/CatalogBrowserContext";
import SidebarCatalogBrowser from "../../../ItemCatalog/SidebarCatalogBrowser";
import WorkareasSection from "./Sidebar/WorkareasSection";

const Sidebar = () => {
  const selectedKey = useEditorSidebarTabKey()

  return <div style={{ width: '380px', flexShrink: 0, flexGrow: 0, backgroundColor: '#f0f0f0', zIndex: 1 }}>
    <div style={sidebarStyle}>
      <EditorSidebarTabs listLabel="Work Areas" listIcon={faTrafficCone} />
      {selectedKey === 'list' && <WorkareasSection />}
      {selectedKey === 'item-catalog' && <SidebarCatalogBrowser />}
    </div>
  </div>
};

export default Sidebar;

const sidebarStyle: React.CSSProperties = {
  overflow: 'auto',
  height: '100vh',
  width: '380px',
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
};
